import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export const useScrollToTop = () => {
  const location = useLocation();
  const routeHistories = useSelector((state: any) => state.Common.routes);
  
  useEffect(() => {
    let scrollPos = 0;
    const path = `${location.pathname}${location.search || ''}`
    const index = routeHistories.map((item: any) => item.path).indexOf(path)
    if (index !== -1) {
      scrollPos = routeHistories[index].scrollPos
    }
    window.scrollTo(0, scrollPos);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
